/**
 * Order statuses handled by the backend (module "orders").
 * The comment above each member is the canonical backend name.
 */
export enum OrderStatus {
  /** PENDING */
  Requested = 0,
  /** STARTED */
  InProgress = 1,
  /** COMPLETED */
  Completed = 2,
  /** CANCELED */
  Canceled = 3,
  /** IN_REVIEW */
  InReview = 4,
  /** APPROVED */
  Aprobado = 5,
  /** APPROVED_WITH_COMMENTS */
  ApprovedWithComments = 6,
  /** CONFIRMED */
  Confirmed = 7,
  /** PENDING_PAYMENT */
  PendingPayment = 8,
}

/**
 * Status written to an order once its payment succeeds, and read back on load
 * to decide whether the success dialog must be shown.
 *
 * ⚠️ PENDING DECISION — status 3 is `Canceled` in the backend enum above.
 *
 * SmartPaymentSolution has used 3 as its "paid" marker since before the enum
 * was mapped here, so every non-Sidney order is currently closed as CANCELED.
 * Writing and reading are symmetrical, so the payment flow behaves correctly
 * from the app's point of view, but any consumer that reads the order status
 * from elsewhere (reports, the orders module, MSAPI) sees a canceled order.
 *
 * This was deliberately left untouched when the Sidney flow was added, to keep
 * that change scoped. Before changing it, confirm with the backend which status
 * a paid non-Sidney order should end up in — most likely `Completed` (2),
 * `Aprobado` (5) or `Confirmed` (7) — and remember that the value is used in
 * two places that must move together:
 *   - `patchOrderStatus()` in payment.component.ts (write)
 *   - `evaluateOrderPaidState()` in payment.component.ts (read)
 * Existing orders already stored as 3 would also need a migration, otherwise
 * previously paid links stop showing the success dialog.
 *
 * Sidney is unaffected: its orders end up as Aprobado (5), as required.
 */
export const PAID_ORDER_STATUS = OrderStatus.Canceled;
export const SIDNEY_PAID_ORDER_STATUS = OrderStatus.Aprobado;
